import React, { useCallback, useEffect, useRef, useState } from "react";
import { FiExternalLink as FiExternalLinkIcon } from "react-icons/fi";
import PropTypes from "prop-types";

import { ButtonLinkStyled } from "../../common/Buttons/Button.Style";

import { ReactComponent as ANSLogo } from "../../../assets/images/icons/agencia-nacional-saude-suplementar-icon.svg";

import * as S from "./FinancialInformationSection.style";

const FinancialInformationSection = ({ title, financialInformationList }) => {
  const itemRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(2);

  const isShowButtoMoreItems = financialInformationList?.length > 4;

  const isEnableMoreItems = Array.isArray(financialInformationList)
    ? visibleCount < financialInformationList.length
    : false;

  const currentBtnLabel = isEnableMoreItems ? "Mostrar mais" : "Mostrar menos";

  const scrollToMyRef = () => {
    const offset = 125;
    const elementTop =
      itemRef.current.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementTop - offset,
      behavior: "smooth",
    });
  };

  const handleClickMoreItems = useCallback(() => {
    if (isEnableMoreItems) {
      setVisibleCount(financialInformationList?.length);
      return;
    }

    setVisibleCount(2);
    scrollToMyRef();
  }, [financialInformationList?.length, isEnableMoreItems]);

  useEffect(() => {
    setVisibleCount(2);
  }, []);

  return (
    <S.FinancialInformationSectionContainer>
      <S.FinancialInformationSectionContent className="container">
        <S.FinancialInformationSectionTitle ref={itemRef}>
          {title}
        </S.FinancialInformationSectionTitle>

        <S.FinancialInformationSectionList>
          {Array.isArray(financialInformationList)
            ? financialInformationList
                .slice(0, visibleCount)
                .map((financialInformationItem) => (
                  <S.FinancialInformationSectionItem
                    key={financialInformationItem?.id}
                  >
                    <S.FinancialInformationSectionItemTitle>
                      {financialInformationItem?.title}
                    </S.FinancialInformationSectionItemTitle>

                    {financialInformationItem.links.map((linkItem) => (
                      <ButtonLinkStyled
                        as="a"
                        key={linkItem?.id}
                        href={linkItem?.href}
                        target="_blank"
                      >
                        <FiExternalLinkIcon size={24} />
                        <span>{linkItem?.label}</span>
                      </ButtonLinkStyled>
                    ))}
                  </S.FinancialInformationSectionItem>
                ))
            : null}

          {isShowButtoMoreItems ? (
            <S.FinancialInformationSectionListFooter>
              <ButtonLinkStyled type="button" onClick={handleClickMoreItems}>
                {currentBtnLabel}
              </ButtonLinkStyled>
            </S.FinancialInformationSectionListFooter>
          ) : null}
        </S.FinancialInformationSectionList>

        <S.FinancialInformationSectionItemFooter>
          <ANSLogo />
        </S.FinancialInformationSectionItemFooter>
      </S.FinancialInformationSectionContent>
    </S.FinancialInformationSectionContainer>
  );
};

FinancialInformationSection.propTypes = {
  title: PropTypes.string.isRequired,
  financialInformationList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.elementType.isRequired,
      href: PropTypes.string,
    })
  ),
};

FinancialInformationSection.defaultProps = {
  financialInformationList: [],
};

export default FinancialInformationSection;
